import {colors, font_s_lg} from '@xpertdox_js/xdstyle';

export default {
  container: {
    background: colors.offWhite,
    overflowY: 'hidden',
    fontSize: '1.2rem',
    padding: '0 0 1.2rem',
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '100%',
    left: 'auto',
    top: 'auto',
    height: '11%',
  },
  headerContainer: {
    padding: '1rem',
    borderTop: '4px solid rgba(0,0,0,0.2)',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
  },
  headerToggle: {
    padding: '1rem',
    borderTop: '4px solid rgba(0,0,0,0.2)',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
    margin: '0',
    fontSize: '1.6rem',
    textAlign: 'left',
    fontWeight: 'bold',
    color: colors.xdDarkBlue,
    width: '100%',
    cursor: 'pointer',
    background: 'rgb(250, 253, 254) none repeat scroll 0% 0%'
  },
  icon: {
    height: 10,
    width: 10,
    fill: colors.xdDarkBlue
  },
  logContainer: {
    overflowY: 'auto',
    padding: '1rem .8rem'
  },
  logEntry: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 5
  }

}
